/**
 * Where the self-hosted MathLive script is served from. In embedded mode the page runs on the
 * StudentPortal origin and `__SANDBOX_PUBLIC_PATH__` holds the Sandbox origin; in standalone mode the
 * page origin is the Sandbox origin.
 */
export const mathLiveScriptUrl = () =>
  `${window.__SANDBOX_PUBLIC_PATH__ || `${window.location.origin}/`}static/mathlive/mathlive.min.js`;
